import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../components/dialog/dialog.component';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DialogInvitesLearnerComponent } from '../../main/components/dialog-invites-learner/dialog-invites-learner.component';
import { InviteLearnerDto } from '../../core/models';
import { DialogMassiveActionsComponent } from '../../main/components/dialog-massive-actions/dialog-massive-actions.component';
import { PrivacyDialogComponent } from '../components/dialog/privacy-dialog/privacy-dialog/privacy-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private privacyDialogOpen = false;

  constructor(
    public dialog: MatDialog,
    private router: Router
  ) { }

  openDialogConfirm(title: string, message: string, showCancelBtn: boolean = true, btnCancel: string, btnConfirm: string, onConfirm?: () => void): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      disableClose: true,
      width: '500px',
      data: { 
        title: title,
        message: message,
        showCancelBtn: showCancelBtn, 
        btnCancel: btnCancel,
        btnConfirm: btnConfirm
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
          onConfirm!();
      }
    });
  }

  openDialogAlert(title: string, message: string, onConfirm?: () => void): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      disableClose: true,
      width: '500px',
      data: { 
        title: title,
        message: message,
        btnConfirm: 'Prosegui'
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
          onConfirm!();
      }
    });
  }

  openDialogInfoNoRedirect(title: string, message: string): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      disableClose: true,
      width: '500px',
      data: { 
        title: title,
        message: message,
        btnConfirm: 'Prosegui'
      },
    });
  }

  openDialogError(title: string, message: string): void {
    this.dialog.open(DialogComponent, {
      disableClose: true,
      width: '500px',
      data: { 
        title: title,
        message: message,
        btnConfirm: 'Torna indietro'
      },
    });
  }

  openDialogErrorNavigateActivity(title: string, message: string): void {
    this.dialog.open(DialogComponent, {
      disableClose: true,
      width: '500px',
      data: { 
        title: title,
        message: message,
        btnConfirm: 'Chiudi'
      },
    });
  }

  // Dialog invite learner
  openDialogInviteLearner(callback?: (formData: InviteLearnerDto) => void): void {
    const dialogRef = this.dialog.open(DialogInvitesLearnerComponent, {
      disableClose: true,
      width: '500px',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && callback) {
        callback(result);
      }
    });
  }

  // Dialog massive actions
  openDialogMassiveActions(callback?: () => void): void {
    const dialogRef = this.dialog.open(DialogMassiveActionsComponent, {
      disableClose: true
    });

    // dialogRef.afterClosed().subscribe(result => {
    //   if (result && callback) {
    //     callback(result);
    //   }
    // });
  }

  openPrivacyDialog(onConfirm?: () => void): void {
    if (this.privacyDialogOpen) return;
    this.privacyDialogOpen = true;

    const dialogRef = this.dialog.open(PrivacyDialogComponent, {
      disableClose: true,
      maxWidth: '900px',
      data: {},
    });

    dialogRef.afterClosed().subscribe(result => {
      this.privacyDialogOpen = false;
      if (result) {
          onConfirm?.();
      }
    });
  }
}
